import React, { FC, useCallback, useState } from 'react';
import { useFormState, useWatch } from 'react-hook-form';
import { AlgorithmFilterClause } from './AlgorithmFilterClause';
import { AlgorithmFilterClauseFormModal } from './AlgorithmFilterClauseFormModal';
import { warningAlgorithmDirty } from '../../../common/form';

interface AlgorithmFormFilterClauseProps {
  isAlgorithmDirty: boolean;
  expanded: boolean;
  onToggle?: (expanded: boolean) => void;
}

export const AlgorithmFormFilterClause: FC<AlgorithmFormFilterClauseProps> = (
  props
) => {
  const { isAlgorithmDirty } = props;
  const id = useWatch({ name: 'id' });
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = useCallback(() => {
    if (isAlgorithmDirty) {
      warningAlgorithmDirty();
    } else {
      setIsModalOpen(true);
    }
  }, [isAlgorithmDirty, setIsModalOpen]);
  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const hasError = Boolean(useFormState().errors.filterClause);

  return (
    <>
      <AlgorithmFilterClause
        {...props}
        algorithmId={id}
        onEditButtonClick={showModal}
        hasError={hasError}
        isLoading={isLoading}
      />
      {isModalOpen && (
        <AlgorithmFilterClauseFormModal
          algorithmId={id}
          onClose={handleCancel}
          onLoadingStateChange={setIsLoading}
        />
      )}
    </>
  );
};
